import { Injectable } from '@angular/core';

@Injectable()
export class RuntimeConfigService {
  private config: { apiBaseUrl?: string } = {};

  load(): Promise<void> {
    const runtimeConfigUrl = new URL('assets/runtime-config.json', document.baseURI).href;

    return fetch(runtimeConfigUrl, {
      cache: 'no-store',
      credentials: 'omit'
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('runtime-config.json not found or unreadable');
        }
        return response.json();
      })
      .then((data) => {
        if (data && typeof data === 'object') {
          this.config = data;
        }
      })
      .catch((error) => {
        this.config = {};
        console.warn('Failed to load runtime config; using defaults.', error);
      });
  }

  getApiBaseUrl(): string {
    const value = this.config && typeof this.config.apiBaseUrl === 'string'
      ? this.config.apiBaseUrl.trim()
      : '';
    return value;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3021582891/src/src/app/shared/services/runtime-config.service.ts